import $ from 'jquery';

export default function correlati() {

  function related() {
    $('.related[data-related]').each(function(){
      let articleURL = $(this).data('related');
      let articleContainer = $(this).data('container');

      $.ajax({
        url:  articleURL + '?int=feed/correlati&ext=feed/struttura-vuota',
        success: function(data,textStatus) {
          $('#'+articleContainer).html(data);
        },
        error: function() {
          //alert("errore");
        }
      });
    });
    
  }
  
  $( document ).ready(function() {
    if($('.related[data-related]').length > 0) {
      related();
    }
  });  
}




























